export default __webpack_public_path__ + "static/banner-pwa-5f9ab472660047c6d9f720b97c29908e.webp";